import { deleteCustomer } from "api/Customers";
import { queryClient } from "lib/helpers/configs/queryClient";
import { useMutation } from "react-query";
import { toast } from "react-toastify";

export const useCustomerDelete = () => {
    return useMutation(deleteCustomer, {
        onSuccess: () => {
            queryClient.invalidateQueries("coustomers");

            toast.success("Deleted Successfully");
        },
        onError: () => {
            toast.error(`Failed to delete`);
        },
    });
};
